module.exports = __webpack_public_path__ + "static/media/ghumba.dc57085c.ogg";